/* eslint-disable */
const icon = require('vue-svgicon')
icon.register({
  'search': {
    viewBox: '0 0 32 32',
    data: `<g><path d="M12,6c-3.3,0-6,2.7-6,6c0,0.6,0.4,1,1,1s1-0.4,1-1c0-2.2,1.8-4,4-4c0.6,0,1-0.4,1-1S12.6,6,12,6z"/><path d="M29.7,28.3l-4-4l-3-3L20.4,19c1.6-1.9,2.6-4.4,2.6-7c0-6.1-4.9-11-11-11S1,5.9,1,12s4.9,11,11,11c2.7,0,5.1-1,7-2.6l2.3,2.3l3,3l4,4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3C30.1,29.3,30.1,28.7,29.7,28.3z M3,12c0-5,4-9,9-9s9,4,9,9s-4,9-9,9S3,17,3,12z"/></g>`
  }
})
